import { listRecentCommitRefs, listUnpushedCommits } from '../../commits/index.js';
import type { WorkingTreeChangeRepoDetail } from '../types.js';

export async function loadRecentAndUnpushedCommitsForRepoDetail(
  repoDir: string,
  recentCommitsLimit: unknown,
): Promise<{
  unpushedCommits: WorkingTreeChangeRepoDetail['unpushedCommits'];
  recentCommits: WorkingTreeChangeRepoDetail['recentCommits'];
  recentCommitsHasMore: boolean;
}> {
  const [unpushedCommits, recentCommitList] = await Promise.all([
    listUnpushedCommits(repoDir),
    listRecentCommitRefs(repoDir, recentCommitsLimit),
  ]);
  const unpushedSet = new Set(unpushedCommits.map((c) => c.sha));
  return {
    unpushedCommits,
    recentCommits: recentCommitList.commits.map((c) => ({
      ...c,
      needsPush: unpushedSet.has(c.sha),
    })),
    recentCommitsHasMore: recentCommitList.hasMore,
  };
}
